import React from 'react';
import { Provider } from 'react-redux';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { IntlProvider } from 'react-intl';
import QueryRenderer from 'relay-query-lookup-renderer';

import { HpRespLayout } from '../homepage/HpRespLayout';
import { homepageRootQuery } from '../queries/homepageRoot';
import serverVars from 'server-vars';
import ReactDOM from 'react-dom';
import { HomePageContextProvider } from '../homepage/HomePageContext';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { defaultLocale } from 'dibs-intl/exports/constants';
import { shopLocalConfig } from '../notifications/shopLocal/shopLocalConfig';
import { notificationsReducer } from '../notifications/notificationsReducer';
import { UIDProvider } from 'dibs-uid';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

const options = {
    notifications: [shopLocalConfig],
    reducers: { notificationsReducer },
};

initializeDBL(options).then(({ store }) => {
    const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
    const homepageUserGroup = serverVars.get('homepageUserGroup');

    ReactDOM.hydrate(
        <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
            <IntlProvider
                locale={serverVars.get('locale')}
                defaultLocale={defaultLocale}
                messages={serverVars.get('messages')}
            >
                <UIDProvider>
                    <HomePageContextProvider
                        isMobile={serverVars.get('settings.isMobile')}
                        isTablet={serverVars.get('settings.isTablet')}
                        isDesktop={serverVars.get('settings.isDesktop')}
                        userType={homepageUserGroup}
                        // userType is only added as a query param for logged-in users
                        isLoggedInUser={!!serverVars.get('userType')}
                    >
                        <Provider store={store}>
                            <QueryRenderer
                                lookup
                                query={homepageRootQuery}
                                variables={serverVars.get('relayVariables')}
                                environment={environment}
                                render={({ props }) => (
                                    <HpRespLayout
                                        homepageUserGroup={homepageUserGroup}
                                        {...props}
                                    />
                                )}
                            />
                        </Provider>
                    </HomePageContextProvider>
                </UIDProvider>
            </IntlProvider>
        </ErrorBoundary>,
        document.getElementById('js-root')
    );
});
